import { render, staticRenderFns } from "./index.vue?vue&type=template&id=45e11ff8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=45e11ff8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e11ff8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45e11ff8')) {
      api.createRecord('45e11ff8', component.options)
    } else {
      api.reload('45e11ff8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=45e11ff8&scoped=true", function () {
      api.rerender('45e11ff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userSystem/setting/index.vue"
export default component.exports